import {inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {IPublicClientApplication, PublicClientApplication} from "@azure/msal-browser";
import {environment} from "../../../environments/environment";
import {serverMsalInstance} from "./msal-server-instance";

/**
 * MSAL instance of the application: Entra ID in the browser, inert on the server.
 *
 * The `e2e` build configuration replaces this file with msal-instance.factory.e2e.ts
 * (fileReplacements in angular.json), so the other bundles never contain the test login.
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return serverMsalInstance();
  }

  return new PublicClientApplication({
    auth: {
      clientId: environment.azureClientId,
      authority: 'https://login.microsoftonline.com/' + environment.azureTenant,
      redirectUri: environment.clientEndpoint + '/admin',
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      allowNativeBroker: false,
      windowHashTimeout: 60000,
      iframeHashTimeout: 6000,
      loadFrameTimeout: 0,
      asyncPopups: false
    }
  });
}
